import { module } from 'modujs';
import {gsap} from 'gsap';
import { MorphSVGPlugin } from "../vendors/gsap/MorphSVGPlugin";
import drawSvgPlugin from '../vendors/gsap/DrawSVGPlugin';
import Utils from "../utils/utils";
export default class extends module {
  constructor(m)
  {
    super(m);

    this.slideIndex = 0
    this.slide = this.el.querySelectorAll('.dotSlider__item')
    this.bullets = this.el.querySelectorAll('.dotSliderBullets')
    this.bulletsMobile = this.el.querySelectorAll('.dotSliderBulletsMobile')
    this.itemContents = this.el.querySelectorAll('.dotSlider__itemContent__sub')
    this.bulletCircles = this.el.querySelectorAll('.dotBulletsCircle')

    gsap.registerPlugin(MorphSVGPlugin);
    gsap.registerPlugin(drawSvgPlugin);

    this.bulletCircles.forEach((item) => {
      gsap.set(item, {rotation:-90, transformOrigin:"center center"});
      gsap.set(item, {drawSVG: "0%"});
    })
    this.TL = gsap.timeline({
      onStart: () => {
        if(Utils.isMobile()) {
          this.bulletCirclesMobile = this.slide[this.slideIndex].querySelectorAll('.dotBulletsCircleMobile')
          this.bulletsMobile = this.slide[this.slideIndex].querySelectorAll('.dotSliderBulletsMobile')
          gsap.to(this.bulletCirclesMobile, {duration: .5, drawSVG: "0%", opacity: 0});
        }

        gsap.to(this.bulletCircles, {duration: .5, drawSVG: "0%", opacity: 0});

      },
      onUpdate: () => {
        gsap.fromTo(this.bulletCircles[this.slideIndex], {opacity: 1}, {drawSVG: Math.round(this.TL.progress() * 100)+"%"});
        if(Utils.isMobile()) {
          gsap.fromTo(this.bulletCirclesMobile[this.slideIndex], {opacity: 1}, {drawSVG: Math.round(this.TL.progress() * 100)+"%"});
        }
      }
    })

    this.TLClose = gsap.timeline()

    //console.log("✅dotSlider✅")
    this.slide[0].classList.remove('slideActive')
    this.initSlider()
    this.bindEvents()
  }

  bindEvents()
  {
    this.switchSlide()
  }

  initSlider()
  {
    this.slideAppear()

    if (window.matchMedia("(min-width: 810px)").matches) {
      const sliders = document.querySelectorAll('.dotSlider.--company');

      if(sliders) {
        sliders.forEach((el) => {
          const items = el.querySelectorAll('.dotSlider__item')

          let highest_slide_size = 0; 
  
          items.forEach((el) => {
            console.log('items.offsetHeight : ', el.offsetHeight)
            if(el.offsetHeight > highest_slide_size) {
              highest_slide_size = el.offsetHeight
            }
          })
  
          if(el.querySelector('.dotSlider__title')) {
            el.querySelector('.dotSlider__items').style.paddingTop = `${highest_slide_size + 64 + 64 - 80 - 48}px`;
          } else {
            el.querySelector('.dotSlider__items').style.paddingTop = `${highest_slide_size + 64 + 64 - 60}px`;
          }       
  
          if(el.querySelector('.dotSlider__ul')) {
            el.querySelector('.dotSlider__ul').style.position = 'absolute';
            el.querySelector('.dotSlider__ul').style.top = `${highest_slide_size + 32}px`;
          }
        })
      }
    }
  }

  // methode qui gère l'apparition d'une slide
  slideAppear()
  {
    this.TL.clear()
    this.TL.fromTo(this.slide[this.slideIndex],{opacity:0},{opacity:1,duration:1,
      onStart:()=>{
        this.slide[this.slideIndex].classList.add('slideActive');
        this.bullets[this.slideIndex].classList.add('dotSlider__bullets--active');
        if(Utils.isMobile()) {
          this.bulletsMobile[this.slideIndex].classList.add('dotSlider__bullets--active');
        }
      }
    })
    this.TL.fromTo(this.itemContents[this.slideIndex].children, {xPercent: 150, opacity: 0, duration: 1}, {xPercent: 0, opacity: 1, duration: 1, stagger: 0.1, ease: "expo.inOut"}, "next")

    console.log('bullets : ', this.bullets.length)
    if(this.bullets.length >= 2) {
      this.TL.add(()=>{
        this.slideDisappear()
      }, "next+=22")
    }
  }

  // methode qui gère la dispartion de la slide
  slideDisappear(index = null)
  {
    this.TLClose.clear()
    this.TLClose.to(this.itemContents[this.slideIndex].children, {xPercent: 150, opacity: 0, duration: 1, stagger: 0.1, ease: "expo.inOut"})
    this.TLClose.fromTo(this.slide[this.slideIndex],{opacity:1},{opacity:0,duration:.25,
      onComplete:()=>{
        this.slide[this.slideIndex].classList.remove('slideActive')
        this.bullets[this.slideIndex].classList.remove('dotSlider__bullets--active');
        if(Utils.isMobile()) {
          this.bulletsMobile[this.slideIndex].classList.remove('dotSlider__bullets--active');
        }

        if (index !== null) {
          this.slideIndex = index
        } else {
          if (this.slideIndex >= this.slide.length -1 ) {
            this.slideIndex = 0
          } else {
            this.slideIndex++
          }
        }

        this.slideAppear()
      }
    })
  }

  // au clique sur un point, on change de slide
  switchSlide()
  {
    this.bullets.forEach((el,index)=>{
      el.addEventListener('click',()=>{
        // console.debug('click on bullet', index)
        this.TL.clear()
        this.slideDisappear(index)
      })
    })
    this.bulletsMobile.forEach((el,index)=>{
      el.addEventListener('click',()=>{
        this.TL.clear()
        this.slideDisappear(el.dataset.index)
      })
    })
  }
  destroy()
  {
    // destroy method
    //console.log('DESTROYED')
    this.TL.kill()
    this.TLClose.kill()
    this.bullets.forEach((el,index)=>{
      el.removeEventListener('click',this)
    })
    this.bulletsMobile.forEach((el,index)=>{
      el.removeEventListener('click',this)
    })
  }
}





// WEBPACK FOOTER //
// ./scripts/modules/dotSlider.js